import { combineEpics } from 'redux-observable';
import { loadMetaEpic } from './loadMeta';
import { updateFocus } from './updateFocus';

export default combineEpics(loadMetaEpic, updateFocus);



// WEBPACK FOOTER //
// ./src/store/meta/epics/index.ts